import React,{ useEffect, useState, useRef} from "react";
import "../assets/css/entete.css";
import { connect } from "react-redux";
// import LegendeCouche from "./LegendeCouche";
import {MenuBoutons,BoutonFiltre   } from '@agam_marseille/package_composants_generiques';
// import MapContext from "../Map/MapContext";
import { Vector as VectorLayer } from 'ol/layer';
import config from '../config';
import pictoFormationPluridisciplinaire from "../assets/pictos/Picto e-sport_Formation pluridisciplinaire.svg"
import pictoStudio from "../assets/pictos/Picto e-sport_Studio.svg"
import pictoCentreEsport from "../assets/pictos/Picto e-sport_Centre esport.svg"
import pictoFormationEsport from "../assets/pictos/Picto e-sport_Formation esport.svg"
import pictoDistributeur from "../assets/pictos/Picto e-sport_Distributeur.svg"
import pictoFormationInformatique from "../assets/pictos/Picto e-sport_Formation informatique.svg"
import pictoEditeur from "../assets/pictos/Picto e-sport_Editeur.svg"
import Legende from '../Controls/Legende'

const MenuDroite = ({ map }) => {

  // const [data,setData]= useState(null)
  // const [visible, setVisible] = useState(true)
  const [listeThematiques, setListeThematiques] = useState(null)
  
  const layersArrayRef = useRef();

  useEffect(()=>{
    const url = config.serveur+`SELECT thematique FROM websig.esport `;
    async function fetchData(url) {
      try {
        let response = await fetch(url);
        // Vérifie si la requête a réussi
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        let data = await response.json();
        let uniqueThematiques = [...new Set(data.map(a => a.thematique).filter(Boolean))];
        uniqueThematiques.sort()
        setListeThematiques(uniqueThematiques)
      } catch (error) {
        console.error("Il y a eu un problème avec l'opération fetch:", error);
      }
    }
    fetchData(url);


  },[])


  useEffect(()=>{
    if (map && typeof map.getLayers === 'function') {
      const layersCollection = map.getLayers();
      layersArrayRef.current = layersCollection.getArray();
    }
  },[map])



  function gestionAffichageCouche(id, couleur, titre){
    const layersCollection = map.getLayers();
    let layersArrayRef = layersCollection.getArray();
    layersArrayRef.map((layer) => {
      let type = layer.get('type')
      if(layer instanceof VectorLayer) {
        if(type === titre){
          let coucheAffichee = layer.getVisible()
          coucheAffichee ? layer.setVisible(false) : layer.setVisible(true)
        }
      }
    });
  }

  function gestionAffichageCoucheParTitre(indexDebut,indexFin){
    //la saisie de texte pour les titres est desactivée en css
    let spanACliquer = document.querySelectorAll('.ButtonContaineur__Checkbox__Span')
    let input = document.querySelectorAll('.ButtonContaineur__Checkbox__Input')
    let unInputChecked = false
    for (let i = indexDebut; i < indexFin; i++) {
      let estCochee = input[i].checked;
      if(estCochee){
        unInputChecked = true
      }
    }
    //si au moins un est checked, on desactive tout
    if(unInputChecked){
      for (let i = indexDebut; i < indexFin; i++) {
        let estCochee = input[i].checked;
        if(estCochee){
          spanACliquer[i].click()
        }
      }
    }else{
      //sinon on reactive tout
      for (let i = indexDebut; i < indexFin; i++) {
          spanACliquer[i].click()
      }
    }
  }

  const fonctions = [gestionAffichageCouche];
 
  function image(titre){
    switch (titre) {
      case 'Formation pluridisciplinaire':
        return pictoFormationPluridisciplinaire
      case 'Studio':
        return pictoStudio
      case "Esport":
        return pictoCentreEsport
      case "Formation esport":
        return pictoFormationEsport
      case "Distributeur":
        return pictoDistributeur
      case "Formation informatique":
        return pictoFormationInformatique
      case "Editeur":
        return pictoEditeur
      default:
        console.log(`erreur de chargement du pictogramme`);
    }
  }


  return (
    listeThematiques&&
    <MenuBoutons >
      <Legende/>
            <h2 className="titre_bouton_legende" onClick={()=>gestionAffichageCoucheParTitre(0,4)}>Entreprises</h2>
            <BoutonFiltre
              key={listeThematiques[0]}
              image={image(listeThematiques[0])}
              titre={listeThematiques[0]}
              fonctions={fonctions}
            />
            <BoutonFiltre
              key={listeThematiques[1]}
              image={image(listeThematiques[1])}
              titre={listeThematiques[1]}
              fonctions={fonctions}
            />
            <BoutonFiltre
              key={listeThematiques[6]}
              image={image(listeThematiques[6])}
              titre={listeThematiques[6]}
              fonctions={fonctions}
            />
            <BoutonFiltre
              key={listeThematiques[2]}
              image={image(listeThematiques[2])}
              titre={listeThematiques[2]}
              fonctions={fonctions}
            />
            <h2 className="titre_bouton_legende" onClick={()=>gestionAffichageCoucheParTitre(4,7)}>Formations</h2>
            <BoutonFiltre
              key={listeThematiques[3]}
              image={image(listeThematiques[3])}
              titre={listeThematiques[3]}
              fonctions={fonctions}
            />
            <BoutonFiltre
              key={listeThematiques[4]}
              image={image(listeThematiques[4])}
              titre={listeThematiques[4]}
              fonctions={fonctions}
            />
            <BoutonFiltre
              key={listeThematiques[5]}
              image={image(listeThematiques[5])}
              titre={listeThematiques[5]}
              fonctions={fonctions}
            />
    
    </MenuBoutons>
  );
};

function mapStateToProps(state) {
  return {
    listecontenu: JSON.parse(state.contenu),
  };
}

export default connect(mapStateToProps, null)(MenuDroite);
